import {
  TOGGLE_LOADING_OVERLAY,
  TOGGLE_MOBILE_FILTERS_OVERLAY
} from './actionTypes'

/**
 * When this value is true, the loading overlay will never display. Use this
 * to temporarily disable the loading overlay (e.g. when clicking View More Flights)
 * @returns {{type, data: *}}
 * @param doDisplay
 */
export function toggleLoadingOverlay(doDisplay) {
  return {
    type: TOGGLE_LOADING_OVERLAY,
    doDisplay
  }
}

export function setCurrentMobileFilter(filterName) {
  return {
    type: TOGGLE_MOBILE_FILTERS_OVERLAY,
    filterName
  }
}
